<script setup lang="ts">
import { computed } from "vue";

const props = defineProps({
  iconName: {
    type: String,
    required: true,
  },
});

const { data: siteIcons } = useLazyFetch<
  Array<{ iconName: string; iconSvg?: string }>
>("/api/site-icons", {
  key: "site-icons",
  server: false,
});

const filteredIcons = computed(() => {
  return (siteIcons.value ?? []).filter(
    (icon) =>
      icon.iconName.trim().toLowerCase() ===
      props.iconName.trim().toLowerCase(),
  );
});
</script>
<template>
  <div class="brand-icons">
    <div
      v-for="icon in filteredIcons.slice(0, 1)"
      :key="icon.iconName"
      class="icon"
    >
      <div v-html="icon.iconSvg" />
    </div>
  </div>
</template>
